/** A Job-less Visit of a plan that is not running says so; pausing writes nothing to the Visit, so this is read from the plan. */
import { VisitBrowseRow } from '@jms/model';
import type { ConditionalTag } from '../../shared/define.conditional.tag';

const PAUSED: ConditionalTag = { label: 'Paused', tone: 'neutral', tooltip: 'The Service Plan is not running' };

export function visitPausedTag(row: VisitBrowseRow | null | undefined): ConditionalTag | null {

  // A Job runs on its own lifecycle once built, so the plan's pause no longer describes it.
  return row?.planPaused && !row.job?._id ? PAUSED : null;
}
